import { __clearTable__, __clearDB__, __del__ } from './db';

function clearTable(tableName: string): any {
    return __clearTable__(tableName);
}

function clear(): void {
    __clearDB__();
}

function del(params: StorageDelParams): any {
    return __del__(params.tableName, params.query);
}

export {
    clearTable,
    clear,
    del
};
